var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { propFunc } from '../../../helpers/custom-prop-types';
import { useCallConsultantSearchCountApi, useConsultantSearchForm, } from '../../../helpers/use/consultant_search/useConsultantSearchCount';
import { useBoolState, useUnmountRef } from '../../../helpers/use/useHook';
import KeyboardArrowDownIcon from '../../Icon/Svg/KeyboardArrowDownIcon';
import SearchSimpleIcon from '../../Icon/Svg/SearchSimpleIcon';
import SubmitButton from '../../Ui/Button/SubmitButton';
import ConsultantSearchSuggestPopper from '../../Ui/ConsultantSearch/ConsultantSearchSuggestPopper';
const ClientHeaderSearch = (props) => {
    const { onChangeKeyword: rawOnChangeKeyword, onChangeSearch: rawOnChangeSearch, onSubmit: rawOnSubmit, } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const [prevKeyword, changePrevKeyword] = useState();
    const { boolState: isFocusSearch, changeFalse: blurSearch, changeTrue: focusSearch, } = useBoolState();
    const { loadTotal } = useCallConsultantSearchCountApi(dispatch);
    const { changeCountData, changeKeyword, changeSearch, keyword, keywordRef, onSearch, search, searchOptions, } = useConsultantSearchForm({
        callback: loadTotal,
        includesSeminar: true,
        unmountRef,
    });
    const onBlurKeyword = useCallback((e) => {
        const { value } = e.currentTarget;
        if (!value) {
            return;
        }
        if (value !== prevKeyword) {
            changePrevKeyword(value);
            if (!rawOnChangeKeyword) {
                changeCountData({ keyword: value });
            }
        }
    }, [changeCountData, prevKeyword, rawOnChangeKeyword]);
    const onChangeKeyword = useCallback((e) => {
        const { value } = e.currentTarget;
        changeKeyword(value);
        if (rawOnChangeKeyword) {
            rawOnChangeKeyword(value);
        }
    }, [changeKeyword, rawOnChangeKeyword]);
    const onClickSearchSuggest = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        const { value } = e.currentTarget;
        const option = searchOptions.find((v) => v.value === value);
        changeSearch(option);
        blurSearch();
        if (rawOnChangeSearch) {
            yield rawOnChangeSearch(option.value);
        }
    }), [searchOptions, changeSearch, blurSearch, rawOnChangeSearch]);
    const onSubmit = useCallback((e) => {
        e.preventDefault();
        // キーワードがなければ検索させない
        if (!keyword) {
            keywordRef.current.focus();
            return;
        }
        blurSearch();
        if (rawOnSubmit) {
            rawOnSubmit(e);
        }
        else {
            onSearch();
        }
    }, [blurSearch, keyword, keywordRef, onSearch, rawOnSubmit]);
    return (_jsx("form", Object.assign({ className: 'client-header-search', onSubmit: onSubmit }, { children: _jsxs("div", Object.assign({ className: 'client-header-search-inner' }, { children: [_jsx(ConsultantSearchSuggestPopper, { className: 'client-header-search-popper-type', isShow: isFocusSearch, onClick: onClickSearchSuggest, suggests: searchOptions, timeout: 300 }), _jsx("div", Object.assign({ className: 'client-header-search-type' }, { children: _jsxs("button", Object.assign({ className: 'client-header-search-type-button', onBlur: blurSearch, onClick: focusSearch, type: 'button' }, { children: [search.label, _jsx(KeyboardArrowDownIcon, {})] })) })), _jsxs("div", Object.assign({ className: 'client-header-search-keyword' }, { children: [_jsx("input", { autoComplete: 'off', className: 'client-header-search-keyword-input input-form-text', name: 'keyword', onBlur: onBlurKeyword, onChange: onChangeKeyword, placeholder: '新規市場、市場調査、など', ref: keywordRef, type: 'search', value: keyword }), _jsx("div", Object.assign({ className: 'client-header-search-keyword-submit' }, { children: _jsx(SubmitButton, { className: 'button primary', isDisabled: false, isLoading: false, text: _jsx(SearchSimpleIcon, { className: 'search_button_icon white' }) }) }))] }))] })) })));
};
ClientHeaderSearch.propTypes = {
    onChangeKeyword: propFunc(),
    onChangeSearch: propFunc(),
    onSubmit: propFunc(),
};
ClientHeaderSearch.defaultProps = {
    onChangeKeyword: undefined,
    onChangeSearch: undefined,
    onSubmit: undefined,
};
export default ClientHeaderSearch;
